// src/services/announcementService.js
// Announcements live on the server only. Errors are passed on to the page so the admin sees them —
// the old localStorage fallback hid every failure (an expired login, a 500) and showed a "saved" copy nobody else could see.
import {
  listAnnouncements as listAnnouncementsApi,
  getAnnouncementById as getAnnouncementByIdApi,
  createAnnouncement as createAnnouncementApi,
  updateAnnouncement as updateAnnouncementApi,
  deleteAnnouncement as deleteAnnouncementApi,
} from "./apiClient";

function toAnnouncementList(apiData) {
  if (Array.isArray(apiData)) return apiData;
  if (Array.isArray(apiData?.items)) return apiData.items;
  if (Array.isArray(apiData?.announcements)) return apiData.announcements;
  return [];
}

function toAnnouncementItem(apiData) {
  if (!apiData || typeof apiData !== "object") return null;
  return apiData.item || apiData.announcement || apiData;
}

// all announcements, newest first (admin list)
export function getAllAnnouncements() {
  return listAnnouncementsApi().then((data) =>
    toAnnouncementList(data).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  );
}

// one announcement (edit page); null when it does not exist
export function getAnnouncementById(id) {
  return getAnnouncementByIdApi(id)
    .then((data) => toAnnouncementItem(data))
    .catch((err) => {
      if (err.status === 404) return null;
      throw err;
    });
}

export function createAnnouncement(data) {
  return createAnnouncementApi(data).then((res) => toAnnouncementItem(res) || res);
}

export function updateAnnouncement(id, data) {
  return updateAnnouncementApi(id, data).then((res) => toAnnouncementItem(res) || res);
}

export function deleteAnnouncement(id) {
  return deleteAnnouncementApi(id);
}
